import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material.module';
import { PipesModule } from '../pipes/pipes.module';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { LockerCancellationDialogComponent } from './components/locker-cancellation-dialog.component';
import { LockerCancellationDialogLoginPageComponent } from './components/locker-cancellation-dialog/locker-cancellation-dialog-login-page.component';  // eslint-disable-line max-len

@NgModule({
    providers: [],
    declarations: [
        LockerCancellationDialogComponent,
        LockerCancellationDialogLoginPageComponent
    ],
    imports: [
        CommonModule,
        AppMaterialModule,
        FlexLayoutModule,
        FormsModule,
        PipesModule,
        SharedComponentsModule
    ],
    exports: [
        LockerCancellationDialogComponent,
        LockerCancellationDialogLoginPageComponent
    ]
})
export class LockerCancellationDialogModule { }
